import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router";
import { Button, TextField, Box, Typography } from "@mui/material";

import { useForm } from "react-hook-form";
import { AuthContext } from "../../utils/userProvider";

import Loader from "../../components/Loader";
import DataTable from "react-data-table-component";

import Swal from "sweetalert2";
import Toast from "../../utils/Toast";

import useGetPromotionRules from "../../queries/system/getPromotionRules";
import addPromoRule from "../../mutation/system/addPromoRule";
import deletePromoRule from "../../mutation/system/deletePromoRule";
import {
  ListPageShell,
  ListPageCard,
  ListPageHeader,
  dataTableCustomStyles,
} from "../../components/ListPage";

const PromotionRules = (props) => {
  const history = useHistory();

  const [rulesTable, setRulesTable] = useState([]);
  const [rulesResponse, resetRules] = useGetPromotionRules();
  const { authState, setAuthState } = useContext(AuthContext);

  const { control, register, handleSubmit, setValue, errors } = useForm({
    //resolver: yupResolver(schema),
  });

  const filteredItems = rulesTable.filter(
    (item) =>
      true /*|| (item.name &&
        item.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.type &&
        typeToText(item.type)
          .toLowerCase()
          .includes(filterText.toLowerCase())) ||
      (item.startDate &&
        moment(item.startDate)
          .format("DD MMM YYYY")
          .toLowerCase()
          .includes(filterText.toLowerCase())) ||
      (item.endDate &&
        moment(item.endDate)
          .format("DD MMM YYYY")
          .toLowerCase()
          .includes(filterText.toLowerCase()))*/
  );

  const goBack = () => {
    window.location.href = "/dashboard/system-setting";
  };
  let columns = [
    {
      name: "Promo / Referral Code",
      selector: "code",
      sortable: true,
    },
    {
      name: "Exclusions",
      selector: "exclusions",
      cell: (row, index, column, id) => {
        let res = [];
        for (var i=0; i<row.exclusions.length; i++) {
          let excl = row.exclusions[i];
          res.push(<li>{excl} | <a href="#" onClick={() => { clickRemove(row.code, excl); return false;}}>Remove</a><br /> </li>);
        }
        return <ul>{res}</ul>;
      },
    }
  ];

  const onSubmit = (values) => {
    runAdd(values.code1, values.code2);
  }

  const clickRemove = (code1, code2) => {
    runDelete(code1, code2);
    return false;
  }

  const runAdd = (code1, code2) => {
    Swal.fire({
      title: "Updating System Settings",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: false,
      showConfirmButton: false,
      willOpen: async () => {
        Swal.showLoading();
        await addPromoRule(code1, code2, authState ? authState.jwt : "")
          .then((response) => {
            Toast.fire({
              icon: "success",
              title: "Update Successful",
            });
            resetRules();
          })
          .catch((err) => {
            if (err.errorMessage.message.message) {
              Swal.fire({
                icon: "error",
                titleText: "Error",
                text: err.errorMessage.message.message,
                allowOutsideClick: true,
                allowEscapeKey: true,
              });
            } else {
              Swal.fire({
                icon: "error",
                titleText: "Error",
                text: "An Error has occured. Please try again.",
                allowOutsideClick: true,
                allowEscapeKey: true,
              });
            }
          });
      },
    });
  };

  const runDelete = (code1, code2) => {
    Swal.fire({
      title: "Updating System Settings",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: false,
      showConfirmButton: false,
      willOpen: async () => {
        Swal.showLoading();
        await deletePromoRule(code1, code2, authState ? authState.jwt : "")
          .then((response) => {
            Toast.fire({
              icon: "success",
              title: "Update Successful",
            });
            resetRules();
          })
          .catch((err) => {
            console.log(err);
            if (err.errorMessage.message.message) {
              Swal.fire({
                icon: "error",
                titleText: "Error",
                text: err.errorMessage.message.message,
                allowOutsideClick: true,
                allowEscapeKey: true,
              });
            } else {
              Swal.fire({
                icon: "error",
                titleText: "Error",
                text: "An Error has occured. Please try again.",
                allowOutsideClick: true,
                allowEscapeKey: true,
              });
            }
          });
      },
    });
  };

  useEffect(() => {
    if (rulesResponse.data) {
      var tableData = [];
      for (var key in rulesResponse.data) {
        tableData.push({code: key, exclusions: rulesResponse.data[key]});
      }
      setRulesTable([...tableData]);
    }
  }, [rulesResponse]);

  const renderContent = () => {
    return (
      <ListPageShell>
        <ListPageCard>
          {rulesResponse.loading && <Loader />}
          {!rulesResponse.loading && (
            <div>
              <ListPageHeader title="Promotion Exclusion Rules" />
              <p>Enter combinations of Promo or Referral codes that are disallowed to be entered together.</p>
              <p>Enter them in any order - so long as two codes are associated in this table, they will be prevented no matter what order they are inputed!</p>
              <DataTable
                pagination
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10]}
                noHeader={true}
                subHeader
                data={filteredItems}
                columns={columns}
                customStyles={dataTableCustomStyles}
              />
            </div>
          )}
        </ListPageCard>
        <Box sx={{ mt: 2 }}>
          <Typography sx={{ fontSize: 16, fontWeight: "bold" }}>
            Add new exception
          </Typography>
          <form noValidate onSubmit={handleSubmit(onSubmit)}>
            <div>
              <TextField
                name="code1"
                margin="normal"
                fullWidth
                label="Promo/Referral Code 1"
                variant="outlined"
                inputRef={register}
                type="text"
                disabled={rulesResponse.loading}
              />
              <TextField
                name="code2"
                margin="normal"
                fullWidth
                label="Promo/Referral Code 2"
                variant="outlined"
                inputRef={register}
                type="text"
                disabled={rulesResponse.loading}
              />
              <Button
                type="submit"
                size="large"
                variant="contained"
                color="primary"
                disabled={rulesResponse.loading}
              >
                Add Exception
              </Button>
            </div>
          </form>
        </Box>
      </ListPageShell>
    );
  };

  return (
    <div>
      {renderContent()}
    </div>
  );
};

export default PromotionRules;
